module.exports = __webpack_public_path__ + "img/flamethrower-turret-damage.6d7cfc61.png";